import AccountsMarketplaceProduct from 'modules/AccountsMarketplace/Product/Product'
import Sagas from 'modules/AccountsMarketplace/Product/saga'
import Reducer from 'modules/AccountsMarketplace/Product/reducer'

export { Sagas, Reducer }

export default AccountsMarketplaceProduct
